import { render, staticRenderFns } from "./RcInfo.vue?vue&type=template&id=1a3e611d&"
import script from "./RcInfo.vue?vue&type=script&lang=js&"
export * from "./RcInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports